import { DeleteOutlined, MoreOutlined } from "@ant-design/icons";
import { Button, Dropdown, DropDownProps } from "antd";
import { observer } from "mobx-react-lite";
import * as React from "react";
import { DeleteConfirm } from "src/components/DeleteConfirm";

import { managementClassifiersStore as pageStore } from "./ManagementClassifiersStore";

export const ManagementClassifiersActions: React.FC = observer(() => {
  const { length } = pageStore.tableStore.selectedKeys;
  const [deleteMode, setDeleteMode] = React.useState(false);
  const menu: DropDownProps["menu"] = {
    items: [
      {
        key: "delete",
        label: "Удалить",
        danger: true,
        icon: <DeleteOutlined />,
        disabled: length === 0,
        title:
          length === 0 ? "Требуется выбрать хотя бы одну строку" : undefined,
        onClick: () => setDeleteMode(true),
      },
    ],
  };
  return (
    <>
      <Dropdown menu={menu}>
        <Button type="text" icon={<MoreOutlined />} />
      </Dropdown>
      <DeleteConfirm
        content="Удалить выделенные классификаторы?"
        open={deleteMode}
        close={() => setDeleteMode(false)}
        task={() => pageStore.deleteRows()}
      />
    </>
  );
});
